<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="amount" slot-scope="{row}">
        <span>{{convertYuan(row.amount)}}</span>
      </template>
      <template v-if="hasApi(['editOrder'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="100">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('editOrder')" type="text" @click="showEdit(row)" :disabled="row.status !== 0">改价</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <order-edit v-if="orderEdit.visible" :dialog-data="orderEdit" @finish="getTableList"/>
  </div>
</template>

<script>
import {billMethod, billOrderType, billStatus, billUserAction, licenseType} from "@utils/formatList";
import OrderEdit from "./dialog/OrderEdit.vue"
export default {
  name: "index",
  components: {OrderEdit},
  data() {
    return {
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "授权类型", property: "uuid_type", format: licenseType, width: 80},
          {label: "下单时间", property: "create_at", width: 140},
          {label: "订单号", property: "order_no", width: 200},
          {label: "订单类型", property: "type", format: billOrderType},
          {label: "充值类型", property: "action", format: billUserAction},
          {label: "支付时间", property: "payment_at", width: 140},
          {label: "支付金额(￥)", property: "amount"},
          {label: "支付方式", property: "method", format: billMethod},
          {label: "订单状态", property: "status", format: billStatus},
          {label: "订单描述", property: "describe", minWidth: 150},
          {label: "购买UUID", property: "uuid", minWidth: 230},
          {label: "通知邮箱", property: "email", minWidth: 150},
          {label: "备注", property: "remark", minWidth: 150, defaultHide: true},
        ],
        api: "getOrderLicense",
      },
      orderEdit: {visible: false, title: "订单价格修改", row: null}
    }
  },
  methods: {
    showEdit(row) {
      this.orderEdit.visible = true;
      this.orderEdit.row = row;
    },
    getTableList() {
      this.$refs["tableRef"].refresh();
    },
  },
}
</script>

<style scoped>

</style>
